import type { KeyboardEvent, MouseEvent, ReactNode } from 'react'
import { cx } from './internal/cx'
import './Card.css'

export type CardProps = {
  padding?: 'sm' | 'md' | 'lg'
  className?: string
  /**
   * When provided the card becomes interactive (role="button", keyboard
   * operable with Enter/Space). Prefer FeatureCard for navigational cards.
   */
  onClick?: (event: MouseEvent<HTMLDivElement>) => void
  children: ReactNode
}

export function Card({ padding = 'md', className, onClick, children }: CardProps) {
  const interactive = typeof onClick === 'function'

  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (!interactive) return
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      event.currentTarget.click()
    }
  }

  return (
    <div
      className={cx('ui-card', `ui-card--${padding}`, interactive && 'ui-card--clickable', className)}
      onClick={onClick}
      role={interactive ? 'button' : undefined}
      tabIndex={interactive ? 0 : undefined}
      onKeyDown={handleKeyDown}
    >
      {children}
    </div>
  )
}
